import type { OverrideTokens } from '@ovComponents/0-tokens/overrideTypes';
import type { RefTokens } from '@ovComponents/0-tokens/ref/refTokens';
import { ref } from '@ovComponents/0-tokens/ref/refTokens';
import type { SysTokens } from '@ovComponents/0-tokens/sys/sysTokens';
import { useSysTokens } from '@ovComponents/0-tokens/sys/sysTokens';
import { merge } from 'lodash-es';

export type Tokens = {
  ref: RefTokens;
  sys: SysTokens;
  comp?: any;
};

export type { OverrideTokens } from '@ovComponents/0-tokens/overrideTypes';

export const useTokens = (override: OverrideTokens): Tokens => {
  const refTokens = merge({}, ref, override.ref);
  const sysTokens = useSysTokens(override);

  return {
    ref: refTokens,
    sys: sysTokens,
  };
};
